import { Box, Typography, Radio } from '@mui/material';
import Image from 'next/image';

const PaymentMethodSelector = ({ t, paymentMethods, selectedPayment, setSelectedPayment }: any) => (
  <Box display="flex" flexDirection="column" gap={2} mb={3}>
    {paymentMethods.map((method: any) => {
      const isSelected = selectedPayment === method.key;
      const iconGroups = method.iconGroups ?? [method.icons];
      const hasIcons = iconGroups.some((icons: string[]) => icons.length > 0);
      const iconHeight = method.iconHeight ?? 16;
      return (
        <Box
          key={method.key}
          onClick={() => !method.disabled && setSelectedPayment(method.key)}
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            p: 2,
            border: '1px solid',
            borderColor: isSelected ? '#1976D2' : '#E0E0E0',
            borderRadius: 3,
            bgcolor: isSelected ? '#F0F7FF' : 'white',
            cursor: method.disabled ? 'not-allowed' : 'pointer',
            opacity: method.disabled ? 0.5 : 1,
            transition: 'all 0.2s',
            minHeight: 80,
          }}
        >
          <Box display="flex" alignItems="flex-start" gap={2} width="100%">
            <Radio
              checked={isSelected}
              sx={{
                p: 0,
                alignSelf: 'center',
                flexShrink: 0,
                color: '#E0E0E0',
                '&.Mui-checked': {
                  color: '#1976D2',
                },
              }}
            />
            <Box display="flex" flex={1} flexDirection="column" gap={1} minWidth={0}>
              <Typography variant="body1" fontWeight={600} fontSize={18}>
                {t(method.label)}
              </Typography>
              {hasIcons && (
                <Box
                  display="flex"
                  flexWrap={method.iconGroups ? 'nowrap' : 'wrap'}
                  alignItems="center"
                  justifyContent={method.iconGroups ? 'space-between' : undefined}
                  sx={method.iconGroups ? { width: '100%' } : undefined}
                >
                  {iconGroups.map((icons: string[], groupIndex: number) => (
                    <Box key={groupIndex} display="flex" alignItems="center" gap="4px">
                      {icons.map((icon: string) => (
                        <Image
                          key={icon}
                          src={icon}
                          alt=""
                          width={40}
                          height={iconHeight}
                          style={{
                            width: 'auto',
                            height: `${iconHeight}px`,
                            maxHeight: `${iconHeight}px`,
                            objectFit: 'contain',
                          }}
                        />
                      ))}
                    </Box>
                  ))}
                </Box>
              )}
            </Box>
            <Image
              src="/assets/icons/chevron-right.svg"
              alt=""
              width={16}
              height={16}
              style={{ alignSelf: 'center', flexShrink: 0 }}
            />
          </Box>
        </Box>
      );
    })}
  </Box>
);

export default PaymentMethodSelector;
